<template>
  <v-navigation-drawer
    app
    width="330"
    :temporary="isSmall"
    :permanent="!isSmall"
    :expand-on-hover="!isSmall"
    :mini-variant.sync="mini"
    v-model="localValue"
    color="primary"
    class="parent-list-overflow"
  >
    <div class="list-overflow d-flex flex-column justify-center navigation-overflow-x">
      <v-list v-if="hasRoleMarketplace" :class="firstMenuClass">
        <v-list-group
          class="item-menu"
          v-model="grupoMarketplace"
          value="true"
        >
          <template v-slot:appendIcon>
            <v-icon color="white">mdi-chevron-down</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon large color="white">mdi-cart-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="white--text">
              <h2>Marketplace</h2>
            </v-list-item-title>
          </template>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/indicadores-marketplace"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Dashboard de vendas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/dashboard-acessos"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Dashboard de acessos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/marketplace/pendencias"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Pendências</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/marketplace/vendas"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Vendas do marketplace</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/marketplace/alertas"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Alertas de preço</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/marketplace/ofertas"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Ofertas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/configuracoes-venda"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Configurações de venda</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/marketplace/configuracoes-frete"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Configurações de frete</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/marketplace/grades"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Grades</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <v-list>
        <v-list-group
          value="true"
        >
          <template v-slot:appendIcon>
            <v-icon color="white">mdi-chevron-down</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon large color="white">mdi-shopping-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="white--text">
              <h2>Cotações</h2>
            </v-list-item-title>
          </template>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/meu-painel"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Painel de cotações</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            class="pl-12"
            active-class="font-weight-bold"
            :class="groupItemClass"
            to="/cotacoes"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Cotações</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            active-class="font-weight-bold"
            class="pl-12"
            to="/vendas"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Vendas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list>
        <v-list-group
          class="item-menu"
          v-model="grupoMinhaEmpresa"
          value="true"
        >
          <template v-slot:appendIcon>
            <v-icon color="white">mdi-chevron-down</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon large color="white">mdi-office-building</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="white--text">
              <h2>Empresa</h2>
            </v-list-item-title>
          </template>
          <v-list-item
            link
            :class="groupItemClass"
            to="/minha-empresa"
            class="pl-12"
            active-class="font-weight-bold"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Minha empresa</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            to="/minha-pagina"
            class="pl-12"
            active-class="font-weight-bold"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Minha página</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            to="/usuarios"
            class="pl-12"
            active-class="font-weight-bold"
          >
            <v-list-item-content class="white--text">
              <v-list-item-title>Usuários</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['value'],
  data() {
    return {
      grupoIndicadores: false,
      grupoMinhaEmpresa: false,
      grupoCatalogo: false,
      grupoMarketplace: true,
      mini: true,
    };
  },
  computed: {
    ...mapGetters('user', ['user', 'hasRoleMarketplace']),
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    groupItemClass() {
      return this.mini ? '' : 'group-item';
    },
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    miniComputed: {
      get() {
        return this.isSmall;
      },
    },
    firstMenuClass() {
      return this.grupoMarketplace ? 'first-menu-opened' : '';
    },
  },
  created() {
    if (this.isSmall) {
      this.mini = false;
    }
  },
};
</script>

<style scoped>
.group-item {
  padding-left: 30px !important;
}

.parent-list-overflow {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.list-overflow {
  width: 100%;
  height: 100%;
  padding-right: 17px;
  overflow-y: scroll;
  box-sizing: content-box;
}

.navigation-overflow-x {
  overflow-x: hidden;
}

.first-menu-opened {
  margin-top: 210px
}
</style>
